/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliTeacherInstitutionMemberDto } from '../../models/amoxcalli-teacher-institution-member-dto';

export interface ApiTeacherInstitutionsByInstitutionInstitutionIdGet$Json$Params {
  institutionId: string;
}

export function apiTeacherInstitutionsByInstitutionInstitutionIdGet$Json(http: HttpClient, rootUrl: string, params: ApiTeacherInstitutionsByInstitutionInstitutionIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliTeacherInstitutionMemberDto>>> {
  const rb = new RequestBuilder(rootUrl, apiTeacherInstitutionsByInstitutionInstitutionIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('institutionId', params.institutionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliTeacherInstitutionMemberDto>>;
    })
  );
}

apiTeacherInstitutionsByInstitutionInstitutionIdGet$Json.PATH = '/api/teacher-institutions/by-institution/{institutionId}';
